import { createContext, useContext, useReducer } from "react";

export const FileStore = createContext<IContextProps>(null);

interface IContextProps {
    state: IState;
    dispatch: ({ type }: Dispatch) => void;
}

type Dispatch = { type, payload }

interface IState {
    search: Search;
    loading: boolean
}
class Search {
    keywords: string;
    storedNumber: string;
    operationName: string;
    startDateTime: string;
    endDateTime: string;
    shopName:string
    shopID:string
};
const initialArgs = {
    dataList: [],
    search: new Search(),
    loading: false
}

function reducer(state: IState, { type, payload }: Dispatch) {
    switch (type) {
        case 'isloading':
            state.loading = payload
            return{
                ...state
            }
        case "SetSearch":
            return {
                ...state,
                search: {
                    ...state.search,
                    ...payload
                }
            }
        default:
            return state;
    }
}

export function FlowStoreProvider(props) {
    const [state, dispatch] = useReducer(reducer, initialArgs);

    const v = { state, dispatch };
    return <FileStore.Provider value={v}>{props.children}</FileStore.Provider>
}